import palette from './palette';
import overrides from './overrides';
import typography from './typography';

export default { palette, ...typography, overrides };
